/**
 * Mirrors `PRESENTATION_SCHEMA_VERSION` from
 * `flow-server/src/modules/ai/contracts/ai-presentation.interface.ts`.
 * Only used to seed a `PresentationDocument` shell client-side before the
 * server's own `assistant.document.meta` event carries the real value.
 */
export const PRESENTATION_SCHEMA_VERSION = '1.0.0';
